module.exports = "<footer id=\"ftr\">\n  <div class=\"container\">\n    <p>Legal content goes here.</p>\n  </div>\n</footer>"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/components/site-footer/site-footer.component.html
// module id = ../../../../../src/app/components/site-footer/site-footer.component.html
// module chunks = main